module.exports = __webpack_public_path__ + "img/title.2b14ff11.png";